import { Theme } from "@emotion/react";
import { Box, SxProps } from "@mui/material";
import { MouseEventHandler } from "react";

import { EntityDefaultValuesMatchStatus } from "@/common/ts/entity";

import AppButton from "../../Button/AppButton";
import AppTypography from "../../Text/AppTypography";

interface Props {
  status: EntityDefaultValuesMatchStatus;
  isAllowCreate?: boolean;
  sx?: SxProps<Theme>;
  onCreate: (() => void) | null;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

export function EntityDefaultValuesMatchStatusDisplay({
  status,
  isAllowCreate,
  sx,
  onCreate,
  onClick,
}: Props) {
  return (
    <Box sx={{ mt: 0.5, ...sx }} onClick={onClick}>
      {status === EntityDefaultValuesMatchStatus.Matched && (
        <Box>
          🟢{" "}
          <AppTypography
            component='span'
            decoration={{ variant: "helpText" }}
            tooltipProps={{
              title: (
                <>
                  Matched with extracted data and auto-selected.
                  {isAllowCreate && <> Also, you can create a new entity instead.</>}
                </>
              ),
              isDefaultEnterDelays: true,
            }}
          >
            Matched
          </AppTypography>
          {isAllowCreate && (
            <>
              :{" "}
              <AppButton
                variant='text'
                size='extraSmall'
                color='primary'
                onClick={() => {
                  onCreate?.();
                }}
              >
                Create new instead
              </AppButton>
            </>
          )}
        </Box>
      )}
      {status === EntityDefaultValuesMatchStatus.Prefilled && (
        <Box>
          🟡{" "}
          <AppTypography
            component='span'
            decoration={{ variant: "helpText" }}
            tooltipProps={{
              title: (
                <>
                  {isAllowCreate && <>Can be quickly created with prefill data.</>}
                  {!isAllowCreate && <>Prefill data available.</>}
                </>
              ),
              isDefaultEnterDelays: true,
            }}
          >
            Prefilled
          </AppTypography>
          {isAllowCreate && (
            <>
              :{" "}
              <AppButton
                variant='text'
                size='extraSmall'
                color='primary'
                onClick={() => {
                  onCreate?.();
                }}
              >
                Create new
              </AppButton>
            </>
          )}
        </Box>
      )}
      {status === EntityDefaultValuesMatchStatus.NoMatch && (
        <Box>
          🔴{" "}
          <AppTypography
            component='span'
            decoration={{ variant: "helpText" }}
            tooltipProps={{
              title: (
                <>
                  No extracted data.
                  {isAllowCreate && <> However, you can create a new entity from scratch.</>}
                </>
              ),
              isDefaultEnterDelays: true,
            }}
          >
            No match
          </AppTypography>
          {isAllowCreate && (
            <>
              :{" "}
              <AppButton
                variant='text'
                size='extraSmall'
                color='primary'
                onClick={() => {
                  onCreate?.();
                }}
              >
                Create new
              </AppButton>
            </>
          )}
        </Box>
      )}
    </Box>
  );
}
